module.exports = "https://static.energy5.com/_next/static/images/placeOrderImage-baf6f6b46012ef69940ef5594e9952fa.jpg";